<template>
  <div class="UploadNotification">
    <div class="flex">
      <div>
        <aw-icon
          icon="upload"
          class="w-6 h-6 text-white "
        />
      </div>
      <div class="pl-4 flex-grow">
        <div 
          class="text-base text-white font-semibold" 
          v-if="isRunning && networkOnline"
        >
          {{ $t('Upload in progress') }}
        </div>
        <div 
          class="text-base text-white font-semibold" 
          v-else-if="isRunning && !networkOnline"
        >
          {{ $t('Upload interrupted') }}
        </div>
        <div 
          class="text-base text-white font-semibold" 
          v-else
        >
          {{ $t('Upload done') }}
        </div>
        <div 
          class="text-sm text-white" 
          v-if="isRunning && networkOnline"
        >
          <div class="flex">
            <div class="flex-grow min-w-0 break-words line-clamp-2">
              {{ $t('Current file:') }} {{ uploadDataCurrentFile?.file.name }}
            </div>
          </div>
          <div class="flex">
            <div class="mr-2">{{ $t('Total uploaded files:') }}</div>
            <div>{{ uploadData?.currentFileIndex }}/{{ uploadData?.files.length }}</div>
          </div>
          <div class="flex items-center">
            <aw-icon
              v-if="!isPaused"
              @click="handlePauseUpload()"
              icon="pause"
              class="w-8 h-8 text-white cursor-pointer"
            />
            <aw-icon
              v-if="isPaused"
              @click="handleResumeUpload()"
              icon="play"
              class="w-8 h-8 text-white cursor-pointer"
            />
            <!-- <span 
              v-if="secondsLeft && !hasError"
              class="mx-2"
            >
              {{ secondsLeft }}s
            </span> -->
            <!-- <span v-if="readableSpeed && !hasError">
              ({{ readableSpeed }})
            </span> -->
          </div>
          <!--
          <div class="flex">
            <div class="mr-2">Estimated time:</div>
            <div>36 seconds</div>
          </div>
          -->
        </div>
        <div 
          v-else-if="isRunning && !networkOnline"
          class="flex items-center mt-2"
        >
          <span>
            {{ $t('Connection lost, upload will resume once your connection is restored.') }}
          </span>
        </div>
      </div>
      <div v-if="uploadDataCurrentFile?.done">
        <aw-icon icon="close" class="w-5 h-5 text-white cursor-pointer" />
      </div>
    </div>
    <div
      v-if="isRunning"
      class="UploadNotification__Progress rounded h-4 border border-gray-200 mt-2"
    >
      <div
        class="bg-white h-full"
        :style="{ width: progress + '%' }"
      ></div>
    </div>
  </div>
</template>

<script>
import { mapStores } from 'pinia'
import AwIcon from 'nette-base-module/js/components/AwIcon.vue'
import { $t } from 'nette-base-module/js/vuei18next'
import useBcUploaderStore from '@/frontapp/store/bcUploader'

export default {
  props: ['toastId'],
  components: {
    AwIcon
  },
  data () {
    return {
      networkOnline: true
    }
  },
  setup() {
    return {
      $t
    }
  },
  computed: {
    ...mapStores(useBcUploaderStore),
    uploadData() {
      return this.bcUploaderStore.getUploaderData(this.toastId)
    },
    uploadDataCurrentFile() {
      return this.uploadData?.files[this.uploadData?.currentFileIndex]
    },
    isPaused() {
      return this.bcUploaderStore.currentFileIsPaused(this.toastId)
    },
    hasError() {
      return this.uploadDataCurrentFile?.hasError
    },
    // secondsLeft() {
    //   if (!this.uploadDataCurrentFile?.stats || this.uploadDataCurrentFile?.stats.secondsLeft === -1) {
    //     return null
    //   }
    //   return this.uploadDataCurrentFile?.stats.secondsLeft
    // },
    // readableSpeed() {
    //   if (!this.uploadDataCurrentFile?.stats || (!this.uploadDataCurrentFile?.stats.speed && this.uploadDataCurrentFile?.stats.speed !== 0) || this.uploadDataCurrentFile?.stats.speed < 0 || this.isPaused) {
    //     return '0 B'
    //   }
    //   return this.uploadDataCurrentFile?.stats.readableSpeed
    // },
    progress() {
      return this.bcUploaderStore.currentFileProgress(this.toastId)
    },
    isRunning() {
      return this.bcUploaderStore.currentUploaderShouldRunning(this.toastId)
    },
  },
  methods: {
    async handlePauseUpload() {
      console.log('handlePauseUpload')
      this.bcUploaderStore.pauseUpload(this.toastId)
    },
    async handleResumeUpload() {
      console.log('handleResumeUpload')
      this.bcUploaderStore.resumeUpload(this.toastId)
    },
    handleNetworkOnline() {
      this.handleResumeUpload()
      this.networkOnline = true
    },
    handleNetworkOffline() {
      this.handlePauseUpload()
      this.networkOnline = false
    }
  },
  mounted() {
    window.addEventListener('online', this.handleNetworkOnline)
    window.addEventListener('offline', this.handleNetworkOffline)
  },
  unmounted() {
    window.removeEventListener('online', this.handleNetworkOnline)
    window.removeEventListener('offline', this.handleNetworkOffline)
  }
}
</script>

<style lang="scss" scoped>
.UploadNotification * {
  //outline: 1px solid red;
}

.UploadNotification {
  &__Progress {
    > div {
      width: 0;
    }
  }
}
</style>
